import $ from 'jquery';
import {createRandomId, is_array, is_function} from '../../../Helpers/js/simple.functions';
import LP from '../0-lp';
import UI from '../0-ui';


LP.questionairePage = {

    pollId: 0,
    busyItems: {},

    init: function () {
        LP.questionairePage.initPollContent();

        LP.dlgThemeColors.prepare('[dialog="themeColors"]', LP.questionairePage.refreshTheme);
        LP.dlgThemeSettings.prepare('[dialog="themeSettings"]', LP.questionairePage.refreshTheme);
        LP.dlgCustomCSS.prepare('[dialog="customCSS"]', LP.questionairePage.refreshCSS);
        LP.dlgPollValidation.prepare('[dialog="pollValidation"]');
        LP.dlgLanguages.prepare('[dialog="languages"]', {afterSubmit: LP.questionairePage.reload});

        $('#lp-preview-button').click(LP.questionairePage.onPreview);

        LP.questionairePage.validationReport();
        LP.questionairePage.initImageChoiceQuestion();
        LP.initLanguages('', LP.questionairePage.changeEditLanguageByBox);
        LP.questionairePage.initCustomTooltips();

        setTimeout(function () {
            $('#lp-questionaire-topbar').sticky({
                context: '.view-poll',
                observeChanges: true
            });
        }, 200);

        $('.refresh-checkpoll a').on('click', function () {
            LP.questionairePage.validationReport();
        });
        $('.lp-multitext-languages').dropdown();

        const themeSwitchDiv = document.getElementById('reactThemeSwitch');
        if (!themeSwitchDiv.getAttribute('data-init')) {
            window.reactPortals.addReactThemeSwitch(themeSwitchDiv);
            themeSwitchDiv.setAttribute('data-init', true);
        }
    },
    initImageChoiceQuestion: function () {
        const $imgs = $('.modern-image img');
        $imgs.each(function () {
            const $img = $(this);
            const $imgWrapper = $img.closest('.image-wrapper');

            if ($imgWrapper.length == 0) {
                $img.wrap('<div class="image-wrapper"></div>');

                const $imgOverlay = $('<div class="img-overlay"></div>');
                $img.closest('.image-wrapper').append($imgOverlay);
            }
        });
    },
    initCustomTooltips: function (element) {
        setTimeout(function () {
            const $customTooltips = element ? $(element).find('.tooltipIcon') : $('.tooltipIcon');
            $customTooltips.each((_, tooltip) => {
                const $tooltip = $(tooltip);
                const $tooltipText = $tooltip.siblings('.tooltip-text').first();
                if (!$tooltip.data('init')) {
                    if (!$tooltipText.hasClass('ui fixed popup')) {
                        $tooltipText.addClass('ui fixed popup'); //Fix for legacy tooltips, which have no "ui fixed popup" class
                    }
                    $tooltip.popup({
                        on: 'hover',
                        popup: $tooltipText
                    });
                    $tooltip.data('init', true);
                }
            });
        }, 200);
    },
    validationReport: function () {
        var pollId = $('#pollId').val();
        if (!pollId) {
            return; // fail soft if validationreport cant be loaded
        }
        $('.loader.loader-icon').show();
        $('.dropdown-button.pollvalidation i').removeClass();

        window.Gateway.UI.Polls.getValidationReport(pollId, function (json) {
            $('#lp-validation-report .validation-item').empty();
            $('.loader.loader-icon, #lp-validation-report >.divider').hide();
            $('.togglebox').hide();
            LP.questionairePage.showValidationReport(json);
        });
    },

    showValidationReport: function (json) {
        if (json.failures) {
            $('#validationErrors').html(json.failures);
            $('.dropdown-button.pollvalidation i').addClass('icon-attention orange icon');
            if (json.warnings) {
                if (json.numErrRows <= 6) {
                    $('#lp-validation-report >.divider').show();
                    $('#validationWarnings').html(json.warnings);
                } else {
                    let textShowMore = $('.togglebox-trigger').data('hidden-text'),
                        iconShowMore = $('.togglebox-trigger').data('hidden-icon'),
                        iconHideInfo = $('.togglebox-trigger').data('visible-icon');
                    $('.togglebox').show();
                    $('.togglebox-content').hide();
                    $('#warnings-content').html(json.warnings);
                    $('.togglebox-trigger').text(textShowMore);
                    $('.toggle-icon').removeClass(iconHideInfo).addClass(iconShowMore);
                }
            }
        } else if (json.warnings) {
            $('#validationWarnings').html(json.warnings);
            $('.dropdown-button.pollvalidation i').addClass('bell outline blue icon');
        } else {
            $('#validationOK').html(json.validPoll);
            $('.dropdown-button.pollvalidation i').addClass('icon-ok green icon');
        }
    },

    onPreview: function () {
        return LP.questionairePage.initPreviewURL();
    },

    getPollId: function () {
        if (!LP.questionairePage.pollId) {
            LP.questionairePage.pollId = $('#pollId').val();
        }

        return LP.questionairePage.pollId;
    },

    getPollURL: function (params) {

        var base_url = $('.lp-base-pollurl').html();
        var poll_name = $('.lp-current-pollname').html();
        if (!poll_name) {
            poll_name = $('.lp-pollname').html();
        }
        var lang = $('#mtLang').val();

        return base_url + poll_name + '/' + lang + '/' + params;
    },

    initPreviewURL: function () {
        return true;
    },

    initPollContent: function () {
        LP.questionairePage.initButtons();
        LP.questionairePage.initItemTitles();
        LP.questionairePage.initSortables();
        LP.questionairePage.initPreviewURL();
        LP.questionairePage.initInlineEditors('#lp-page-questionaire ', LP.questionairePage.onSaveText);

        LP.UI.jQPlot.loadCharts();
        UI.triggerEvent('onInit');
    },

    initButtons: function (prefix) {
        prefix = prefix ? (prefix + ' ') : '#lp-page-questionaire ';
        $(prefix + 'a[action="newPage"]').click(LP.questionairePage.createNewPage);

        LP.questionairePage.initPageButtons(prefix);
        LP.questionairePage.initItemButtons(prefix);

    },

    initItemTitles: function () {
        const items = $('ul.lp-item-list li.lp-page-item');

        items.each(function () {
            const item = $(this);

            if ($('a[action="openItem"][type="item"]', item).isVisible()) {
                $('.item-title-text', item).eq(0).css('display', 'inline-block');
            } else {
                $('.item-title-text', item).eq(0).hide();
            }
        });
    },

    initPageButtons: function (prefix) {
        LP.dlgPage.prepare(prefix + 'a[dialog="page"]', {afterSubmit: LP.questionairePage.reloadPage});
        LP.dlgPageVisible.prepare(prefix + 'a[dialog="pageVisibility"]', {afterSubmit: LP.questionairePage.reloadPage});
        LP.dlgPageJumps.prepare(prefix + 'a[dialog="pageJumps"]', {afterSubmit: LP.questionairePage.reloadPage});
        LP.dlgClonePage.prepare(prefix + 'a[dialog="clonePage"]', {afterSubmit: LP.questionairePage.insertPage});

        $(prefix + 'a[action="toggleFixPos"]').click(LP.questionairePage.toggleFixPosition);
        $(prefix + 'a[action="deleteItem"]').click(LP.questionairePage.deleteItem);

        $(prefix + 'a[action="openItem"]').click(LP.questionairePage.openItem);
        $(prefix + 'a[action="closeItem"]').click(LP.questionairePage.closeItem);
        $(prefix + 'a[action="openAllItems"]').click(function () {
            var $parentPage = $(this).closest('.pollPageItem');
            $('a[action="openItem"][type="item"]', $parentPage).trigger('click');
        });
        $(prefix + 'a[action="closeAllItems"]').click(function () {
            var $parentPage = $(this).closest('.pollPageItem');
            $('a[action="closeItem"][type="item"]', $parentPage).trigger('click');
        });
        $(prefix + 'a[action="openAllPages"]').click(function () {
            $('a[action="openItem"][type="page"]').trigger('click');
        });
        $(prefix + 'a[action="closeAllPages"]').click(function () {
            $('a[action="closeItem"][type="page"]').trigger('click');
            window.scrollTo(0, 0);
        });

        $(prefix + 'a[action="changeLanguage"]').click(LP.questionairePage.changeEditLanguage);
        $(prefix + '[action="toggleProgressBar"]').change(LP.questionairePage.toggleProgressbar);
        $(prefix + '[action="toggleLanguageBar"]').change(LP.questionairePage.toggleLanguagebar);

        $(prefix + '[action="toggleLogo"]').on('click', function (e) {
            e.stopPropagation();
        });
        $(prefix + '[action="toggleLogo"]').on('change', LP.questionairePage.toggleLogo);

        if (!$(prefix + ' .pollLogo').hasClass('viewOnly')) {
            var $logoform = $('#logoform');
            const isThemeV5 = $('.poll').hasClass('thV5');
            $(prefix + ' .lp-logo-wrapper').each(function (index, elm) {
                if (isThemeV5) {
                    LP.questionairePage.initUploadLogoForm(LP.questionairePage.onSaveLogo);
                } else {
                    $(elm).popup({
                        on: 'click',
                        observeChanges: false,
                        html: $logoform.html(),
                        onCreate: LP.questionairePage.initLogoForm
                    });
                }
            });

            $(prefix + ' [action="deleteLogo"]').lpConfirmDeletion('click', LP.questionairePage.deleteLogo);
            $(prefix + '[action="moveLogoToTheRight"]').on('click', LP.questionairePage.moveLogoToTheRight);
            $(prefix + '[action="moveLogoToTheLeft"]').on('click', LP.questionairePage.moveLogoToTheLeft);
        }

        LP.dlgQuestion.prepare(prefix + 'a[dialog="question"]', {afterSubmit: LP.questionairePage.pageitemDlgSubmitted});
        LP.dlgQuestionWizard.prepare(prefix + 'a[dialog="new_question"]', {afterSubmit: LP.questionairePage.pageitemDlgSubmitted});
        LP.dlgQuestionVisible.prepare(prefix + 'a[dialog="questVisibility"]', {afterSubmit: LP.questionairePage.pageitemDlgSubmitted});

        // Insert Textbox on-the-fly
        $(prefix + 'a[dialog="new_textblock"]').click(function () {
            var url = $(this).attr('url');
            var params = $(this).attr('url_params');
            window.Browser.send(url, params, LP.questionairePage.pageitemDlgSubmitted);
        });

        LP.dlgTextBlockVisible.prepare(prefix + 'a[dialog="textVisibility"]', {afterSubmit: LP.questionairePage.pageitemDlgSubmitted});

        LP.dlgResultView.prepare(prefix + 'a[dialog="resultview"]', {afterSubmit: LP.questionairePage.pageitemDlgSubmitted});
        LP.dlgResultTabVisible.prepare(prefix + 'a[dialog="resultVisibility"]', {afterSubmit: LP.questionairePage.pageitemDlgSubmitted});

        LP.dlgClonePageItem.prepare(prefix + 'a[dialog="clonePageItem"]', {afterSubmit: LP.questionairePage.insertPageItem});

        // Page-Header Click
        $(prefix + '.lp-page-toolbar').click(function () {
            if ($('a[action="openItem"][type="page"]', this).isVisible()) {
                $('a[action="openItem"][type="page"]', this).click();
            } else {
                $('a[action="closeItem"][type="page"]', this).click();
            }
        });

        // Question-Header Click
        $(prefix + '.lp-item-toolbar').click(function () {
            if ($('a[action="openItem"][type="item"]', this).isVisible()) {
                $('a[action="openItem"][type="item"]', this).click();
            } else {
                $('a[action="closeItem"][type="item"]', this).click();
            }
        });

        // ResultView-Header Double-Click
        $(prefix + '.lp-r-item-header').dblclick(function () {
            if ($('a[action="openItem"][type="item"]', this).isVisible()) {
                $('a[action="openItem"][type="item"]', this).click();
            } else {
                $('a[action="closeItem"][type="item"]', this).click();
            }
        });

        // TextBlock-Header Double-Click
        $(prefix + '.lp-t-item-header').dblclick(function () {
            if ($('a[action="openItem"][type="item"]', this).isVisible()) {
                $('a[action="openItem"][type="item"]', this).click();
            } else {
                $('a[action="closeItem"][type="item"]', this).click();
            }
        });
    },

    initInlineEditors: function (selector, onSaveCallback) {
        const editableContents = document.querySelectorAll(selector + ' [data-editable=true]');
        Array.from(editableContents).forEach((contentDiv) => {
            if (!contentDiv.getAttribute('data-init')) {
                window.reactPortals.addPollTextEditor(contentDiv, {onSave: onSaveCallback, onClose: LP.questionairePage.initCustomTooltips});
                contentDiv.setAttribute('data-init', true);
            }
        });

    },

    onSaveText: function (element, json) {
        LP.questionairePage.initCustomTooltips(element);
        var params = $.deparam(element.getAttribute('data-params'));
        if (params.item) {
            LP.questionairePage.updateElementTitle(params.item, json.title);
        } else if (params.page) {
            LP.questionairePage.updatePageTitle(params.page, json.html);
        }
        return json;
    },

    initUploadLogoForm: function (onSaveCallback) {
        const imageEditorDiv = document.getElementById('reactImageEditor');
        if (!imageEditorDiv.getAttribute('data-init')) {
            window.reactPortals.addReactImageEditor(imageEditorDiv, {onSave: onSaveCallback});
            imageEditorDiv.setAttribute('data-init', true);
        }
    },

    onSaveLogo: function (imageUrl) {
        LP.dlgPollValidation.doRefresh = true;
        if (imageUrl) {
            var src = imageUrl;
            $('.pollLogo').attr('src', src);
            $('.lp-deletelogo-button').each(function (index, elm) {
                var $elm = $(elm);
                var parent = $elm.closest('.lp-logo');
                if ($('[action="toggleLogo"]:checked', parent).length > 0) {
                    $elm.show();
                }
            });
            $('.lp-rightLogo-button').each(function (index, elm) {
                var $elm = $(elm);
                var parent = $elm.closest('.lp-logo');
                if ($('[action="toggleLogo"]:checked', parent).length > 0) {
                    $elm.show();
                }
            });
            $('.lp-leftLogo-button').each(function (index, elm) {
                var $elm = $(elm);
                var parent = $elm.closest('.lp-logo');
                if ($('[action="toggleLogo"]:checked', parent).length > 0) {
                    $elm.show();
                }
            });
        }
        $('.lp-logo .legy-marker.ui.warning.message,.lp-no-logo').hide();
        $('.pollLogo').show();
    },

    initItemButtons: function (prefix) {
        // Placeholder-Click edit
        $(prefix + ' .lp-question-edit').click(function (e) {
            if ($(e.target).hasClass('lp-question-edit')) {
                var parent = $(this).closest('.lp-page-item');
                $('a[dialog="question"]', parent).click();
            }
        });

        LP.dlgQuestion.prepare(prefix + ' a.lp-pageitem-edit-button', {afterSubmit: LP.questionairePage.pageitemDlgSubmitted});

        $(prefix + ' .lp-textblock-edit').click(function () {
            var parent = $(this).closest('.lp-page-item');
            $('a[dialog="textblock"]', parent).click();
        });
        $(prefix + ' .lp-resultview-edit').click(function () {
            var parent = $(this).closest('.lp-page-item');
            $('a[dialog="resultview"]', parent).click();
        });

        $('a[dialog="editComment"]').click(LP.commentsDlg.open);

    },

    initSortables: function () {
        LP.questionairePage.makePagesSortable();

        var pages = $('ul.lp-list-pages li.pollPageItem');
        pages.each(function (i, page) {
            LP.questionairePage.makePageItemsSortable($(page));
        });
    },

    createNewPage: function () {
        const $this = $(this);
        if ($this.is('[disabled]')) {
            return false;
        }
        var url = $this.attr('url');
        var params = $this.attr('url_params');
        window.Browser.send(url, params, LP.questionairePage.newPageCreated);

        return false;
    },

    newPageCreated: function (json) {
        $('#noPagesHint').hide();

        if ($('#pages').length == 0) {
            window.Browser.send('backend/openItem/', 'page=' + json.pageId);
            LP.questionairePage.reload();
        } else {
            LP.questionairePage.insertPage(json);
        }
    },

    pageitemDlgSubmitted: function (json) {
        if (json.created) {
            LP.questionairePage.insertPageItem(json);
        } else {
            window.Browser.send('backend/openItem', 'poll=' + LP.questionairePage.getPollId() + '&pageitem=' + json.pageitemId);
            LP.questionairePage.reloadPageItem(json);
        }
    },

    insertPage: function (json) {
        if (!json || !json.pageId) {
            return;
        }

        var onSuccess = function (pageData) {
            var itemId = 'page_' + json.pageId;
            var newPage = $('<li id="' + itemId + '" class="pollPageItem">');
            newPage.hide().html(pageData.html).appendTo('#pages');
            LP.questionairePage.refreshPage(json.pageId, false);
            LP.questionairePage.refreshProgressbars();
            newPage.show();
            newPage.find('a[action="openItem"][type="page"]').click();
            UI.triggerEvent('onInit', '#' + itemId);
            UI.triggerEvent('onUpdate', '#' + itemId);
            $.scrollTo(newPage, 800);
        };

        window.Browser.send('backend/getPage/', '&page=' + json.pageId, onSuccess);
    },

    insertPageItem: function (json) {
        if (json.pageId && json.pageitemId) {
            var content = $('#pageContent_' + json.pageId);
            if ($.trim(content.html()) == '') {
                $('#page_' + json.pageId + ' .openPage').click();
            } else {
                var onSuccess = function (pageItemData) {

                    LP.dlgPollValidation.doRefresh = true;
                    var itemId = 'pageitem_' + json.pageitemId;
                    var newPageItem = $('<li id="' + itemId + '" class="lp-page-item">');
                    newPageItem.hide().html(pageItemData.html).appendTo('#lp-pageitems_' + json.pageId);
                    LP.questionairePage.initItemTitles();

                    // for cloning items to closed pages
                    if (!content.isVisible()) {
                        $('#page_' + json.pageId + ' a[action="openItem"]').click();
                    } else {
                        LP.questionairePage.refreshPageItem(json.pageId, json.pageitemId, false, false);
                        LP.questionairePage.initInlineEditors('#' + itemId, LP.questionairePage.onSaveText);
                    }

                    newPageItem.show(0, function () {
                        UI.triggerEvent('onInit', '#' + itemId);
                        UI.triggerEvent('onUpdate', '#' + itemId);
                        UI.triggerEvent('onShow', '#' + itemId);

                        var title = $('.questionText', '#' + itemId);
                        if (title.length > 0) {
                            title.click();
                        }

                        LP.UI.jQPlot.loadCharts();
                    });

                    if ((!json.isCloned && !json.isMoved) || !json.sourcePage) {
                        $.scrollTo(newPageItem, 800);
                    } else {

                        if (json.isMoved) {
                            var jsonX = {...json};
                            jsonX.pageId = json.sourcePage;
                            //reload source page
                            LP.questionairePage.reloadPage(jsonX);
                        }

                        $.scrollTo(newPageItem, 800);
                    }
                };
                window.Browser.send('backend/getPageItem/', 'poll=' + $('#pollId').val() + '&pageitem=' + json.pageitemId, onSuccess, null, false);
            }
        }
    },

    changeEditLanguage: function () {
        LP.questionairePage.refreshPageWithLang($(this).attr('code'));
        return false;
    },

    changeEditLanguageByBox: function (code) {
        LP.questionairePage.refreshPageWithLang(code);
        return false;
    },

    // dies ist die Funktion, die explizit ein refresh der seite in einer bestimmten Sprache veranlasst
    // diese hier soll/kann auch extern von Dialogen etc. aufgerufen werden, ohne, dass die Sprach-Auswahlbox
    /* verändert wurde */
    refreshPageWithLang: function (language) {
        $('#mtLang').val(language);

        $('.lp-multitext-languages').val(language);

        var printLink = $('#lp-preview-print-link');
        var printURL = printLink.attr('url');
        var printParams = printLink.attr('url_params');
        printLink.attr('href', printURL + language + '/' + printParams);

        LP.questionairePage.reload();
    },

    reload: function () {
        var params = 'poll=' + $('#pollId').val() + '&edit_lang=' + $('#mtLang').val();
        window.Browser.loadHTML($('#pollArea'), 'backend/getPollArea/', params, function () {
            LP.questionairePage.initPollContent();
        });
    },

    replacePollHTML: function (json) {
        $('#pollArea').html(json.pollHTML);
        LP.questionairePage.initPollContent();
        $('body').css('cursor', 'inherit');
    },

    reloadPage: function (json) {
        if (!json.pageId) {
            return;
        }

        var params = $.param({
            poll: $('#pollId').val(),
            page: json.pageId,
            edit_lang: $('#mtLang').val()
        });

        window.Browser.loadHTML($('#page_' + json.pageId), 'backend/getPage/', params, function () {
            LP.questionairePage.refreshPage(json.pageId, true, true);
        });
    },

    reloadPageItem: function (json) {
        var params = 'poll=' + $('#pollId').val() + '&pageitem=' + json.pageitemId + '&edit_lang=' + $('#mtLang').val();
        window.Browser.loadHTML($('#pageitem_' + json.pageitemId), 'backend/getPageItem/', params, function () {
            LP.questionairePage.refreshPageItem(json.pageId, json.pageitemId, true, true);
        });
    },

    refreshPage: function (pageId, doUpdate, doInit) {
        LP.dlgPollValidation.doRefresh = true;
        var itemId = '#page_' + pageId;
        LP.questionairePage.numeratePages();
        LP.questionairePage.initButtons(itemId + ' ');
        LP.questionairePage.initItemTitles();
        LP.questionairePage.makePageItemsSortable(itemId);
        LP.questionairePage.validationReport();
        LP.questionairePage.initInlineEditors('#page_' + pageId, LP.questionairePage.onSaveText);

        if (doInit) {
            UI.triggerEvent('onInit', itemId);
        }

        if (doUpdate) {
            UI.triggerEvent('onUpdate', itemId);
        }
    },

    refreshPageItem: function (pageId, pageItemId, doUpdate, doInit) {
        LP.dlgPollValidation.doRefresh = true;
        var itemId = '#pageitem_' + pageItemId;
        LP.questionairePage.numeratePageItems('#lp-pageitems_' + pageId, true);
        LP.questionairePage.initButtons(itemId + ' ');
        LP.questionairePage.makePageItemsSortable($('#page_' + pageId));
        LP.questionairePage.initInlineEditors(itemId, LP.questionairePage.onSaveText);
        LP.questionairePage.validationReport();
        LP.questionairePage.initCustomTooltips();
        if (doInit) {
            UI.triggerEvent('onInit', itemId);
        }
        if (doUpdate) {
            UI.triggerEvent('onUpdate', itemId);
        }
    },

    openItem: function () {
        var $anchor = $(this);
        var item = LP.questionairePage.findItemBlock($anchor);
        if (!item.elm || LP.questionairePage.busyItems[item.id]) {
            return;
        }
        var content = $('.lp-content-div', item.elm).eq(0);
        if (content.is(':hidden')) {
            LP.questionairePage.busyItems[item.id] = true;
            if ($.trim(content.html()) == '') {
                window.Browser.loadHTML(content, $anchor.attr('url'), $anchor.attr('url_params'), function () {
                    if (item.type == 'page') {
                        UI.triggerEvent('onInit', '#page_' + item.id);
                        LP.questionairePage.makePageItemsSortable($('#page_' + item.id));
                        LP.questionairePage.initButtons('#pageContent_' + item.id + ' ');
                        LP.questionairePage.busyItems[item.id] = false;
                        LP.questionairePage.initInlineEditors('#page_' + item.id, LP.questionairePage.onSaveText);
                    } else {
                        UI.triggerEvent('onInit', '#pageitem_' + item.id);
                        LP.questionairePage.initItemButtons('#pageitem_' + item.id);
                        LP.questionairePage.busyItems[item.id] = false;
                        LP.questionairePage.initInlineEditors('#pageitem_' + item.id, LP.questionairePage.onSaveText);
                    }
                    LP.UI.jQPlot.loadCharts();
                });
            } else {
                window.Browser.send('backend/openItem/', 'poll=' + LP.questionairePage.getPollId() + '&' + item.type + '=' + item.id, function () {
                    LP.questionairePage.busyItems[item.id] = false;
                });
            }
            content.parent().show();

            if (item.type == 'page') {
                $('.pagequestionsbar', item.elm).eq(0).show();
            }

            $('a[action="openItem"]', item.elm).eq(0).hide();
            $('a[action="closeItem"]', item.elm).eq(0).css('display', 'inline-block');
            $('.item-title-text', item.elm).eq(0).css('display', 'none');
        }
    },

    closeItem: function () {
        var $anchor = $(this);
        var item = LP.questionairePage.findItemBlock($anchor);
        if (!item.elm || LP.questionairePage.busyItems[item.id]) {
            return;
        }
        var content = $('.lp-content-div', item.elm).eq(0);
        if (!content.is(':hidden')) {
            LP.questionairePage.busyItems[item.id] = true;
            content.parent().slideUp(300);

            window.Browser.send('backend/closeItem/', 'poll=' + LP.questionairePage.getPollId() + '&' + item.type + '=' + item.id, function () {
                LP.questionairePage.busyItems[item.id] = false;
            });

            if (item.type == 'page') {
                $('.pagequestionsbar', item.elm).eq(0).hide();
            }

            $('a[action="openItem"]', item.elm).eq(0).css('display', 'inline-block');
            $('a[action="closeItem"]', item.elm).eq(0).hide();
            $('.item-title-text', item.elm).eq(0).css('display', 'inline-block');
        }
    },

    toggleFixPosition: function () {
        var $this = $(this);
        if ($this.is('[disabled]')) {
            return false;
        }
        var fixed = $this.attr('value') == '1' ? false : true;
        $this.attr('value', fixed ? '1' : '0');
        $this.toggleClass('icon-pin', fixed).toggleClass('icon-pin-1', !fixed);

        window.Browser.send('backend/setFixItemPosition/', 'poll=' + LP.questionairePage.getPollId() + '&' + $this.attr('type') + '=' + $this.attr('iid') + '&fixed=' + $this.attr('value'));

        return false;
    },

    deleteItem: function () {
        var $this = $(this);
        if ($this.is('[disabled]')) {
            return false;
        }
        var url = $this.attr('url');
        var params = $this.attr('url_params');
        var item = LP.questionairePage.findItemBlock($this);
        if (item.elm) {
            LP.UI.warnConfirm($this, function () {
                UI.triggerEvent('onDelete', '#' + item.elm.attr('id'));
                var list = $(item.elm).parent();
                item.elm.slideUp(100, function () {

                    window.Browser.send(url, params, () => {
                        $(this).remove();
                        LP.questionairePage.numeratePageItems(list, false);
                        LP.questionairePage.refreshProgressbars();
                        LP.questionairePage.validationReport();
                    }, () => {
                        $(this).slideDown(100);
                    });
                });
            });
        }
        return false;
    },

    makePagesSortable: function () {
        var pageList = $('ul.lp-list-pages');
        if (!pageList || pageList.length == 0) {
            return;
        }

        // Safe delete for jQuery UI 1.8.5
        try {
            pageList.sortable('destroy');
        } catch {
        }

        pageList.sortable({
            handle: '.movablePage',
            scroll: true,
            forcePlaceholderSize: true,
            revert: true,
            cursor: 'move',
            dropOnEmpty: true,
            placeholder: 'sort-pages-placeholder',
            opacity: 0.75,
            items: 'li.pollPageItem',
            tolerance: 'intersect',
            stop: function (event, ui) {
                var pageId = $(ui.item).attr('id').substr(5);
                var url = 'backend/savePagePositions/';
                var params = $(this).sortable('serialize');
                params += '&poll=' + LP.questionairePage.getPollId();
                window.Browser.send(url, params, function () {
                    LP.questionairePage.numeratePageItems('#lp-pageitems_' + pageId, true);
                    LP.questionairePage.refreshProgressbars();
                });
            }
            /*update:function(event,ui) { }*/
        });
    },

    makePageItemsSortable: function (page) {
        var itemList = $('ul.lp-list-items', page);
        if (!itemList || itemList.length == 0) {
            return;
        }

        // Safe delete for jQuery UI 1.8.5
        try {
            itemList.sortable('destroy');
        } catch {
        }

        itemList.sortable({
            handle: '.movablePageItem',
            connectWith: 'ul.lp-list-items', // connect to all other lp-list-items
            scroll: true,
            forcePlaceholderSize: true,
            revert: true,
            cursor: 'move',
            dropOnEmpty: true,
            placeholder: 'sort-items-placeholder',
            opacity: 0.75,
            items: 'li.lp-page-item',
            tolerance: 'pointer',
            start: function (event, ui) {
                var list = $(ui.item).parent();
                LP.questionairePage.spaceDropPlaceholder(list, $('li.lp-page-item', list), true);
                ui.item.data('start_pos', ui.item.index()); // attach start_pos to element
            },
            stop: function (event, ui) {
                var start_pos = ui.item.data('start_pos'); // get start_pos from element
                var prevList = $(this);
                var newList = $(ui.item).parent();
                var prevPageId = prevList.attr('id').split('_')[1];
                var newPageId = newList.attr('id').split('_')[1];
                var pollId = LP.questionairePage.getPollId();

                if (prevPageId != newPageId || start_pos != ui.item.index()) { // only if position changed
                    window.Browser.send(
                        'backend/savePageItemPositions/',
                        prevList.sortable('serialize') + '&poll=' + pollId + '&page=' + prevPageId,
                        function () {
                            return LP.questionairePage.numeratePageItems(prevList, true);
                        }
                    );

                    if (prevPageId != newPageId) {
                        window.Browser.send(
                            'backend/savePageItemPositions/',
                            newList.sortable('serialize') + '&poll=' + pollId + '&page=' + newPageId,
                            function () {
                                return LP.questionairePage.numeratePageItems(newList, true);
                            }
                        );
                    }
                }
            }
        });

        LP.questionairePage.spaceDropPlaceholder(itemList, $('li.lp-page-item', itemList), false);
    },

    numeratePages: function () {
        var pollId = LP.questionairePage.getPollId();

        window.Browser.send('backend/getPageNumbering/', 'poll=' + pollId, function (json) {
            var pages = $('ul.lp-item-list li.pollPageItem');
            if (pages.length == 0) {
                $('#noPagesHint').show();
            }

            var numbering = $(json.numbering);

            pages.each(function (index, page) {
                LP.questionairePage.updatePage(page, numbering[index]);
            });
        });
    },

    numeratePageItems: function (list, setupSpaceHolders) {
        var pollId = LP.questionairePage.getPollId();

        window.Browser.send('backend/getQuestionNumbering/', 'poll=' + pollId, function (json) {
            var pages = $('ul.lp-item-list li.pollPageItem');
            var numbering = $(json.numbering);
            var indexing = $(json.indexing);

            pages.each(function (index, page) {
                var items = $('ul.lp-item-list li.lp-page-item', page);
                if (list && setupSpaceHolders) {
                    LP.questionairePage.spaceDropPlaceholder(list, items, false);
                }

                // Update Page status
                LP.questionairePage.updatePage(page, indexing[index]);

                // Update PageItem status
                LP.questionairePage.updatePageItems(items, numbering);
            });
        });
    },

    updatePage: function (page, data) {
        // Update page numbers
        var parent = $(page).closest('.pollPageItem');
        $('.pageNum', parent).html(data.index);
        $('.pageNumber', parent).html(data.index + '.');
    },

    updatePageItems: function (items, numbering) {
        if (items.length == 0) {
            return;
        }

        items.each(function (id, item) {
            item = $(item);
            var itemId = item.attr('id');
            var questId = itemId.replace('pageitem_', '');
            var questNum = 0;

            for (var i = 0; i < numbering.length; i++) {
                if (numbering[i].id == questId) {
                    questNum = numbering[i].num;
                    break;
                }
            }

            $('.itemNumber', item).html(questNum);
            $('.questionNumber', item).html(questNum + '.');
        });
    },

    updatePageTitle: function (pageId, text) {
        var titlebar = $('#page_' + pageId + ' .page-title-text');
        text = text.replace(/<[^>]*>/g, '');
        titlebar.html(text);
    },

    updateElementTitle: function (itemId, text) {
        var titlebar = $('#pageitem_' + itemId + ' .item-title-text');
        text = text.replace(/<[^>]*>/g, '');
        titlebar.html(text);
    },

    refreshProgressbars: function () {
        var pages = $('.pollPageItem');

        if (pages.length == 0) {
            return;
        }

        var total = pages.length;
        pages.each(function (index) {
            $(this).find('.progress-bar').each(function () {
                var $this = $(this);
                if ($(this).data('mode') == 'page') {
                    var percent = Math.round(((index + 1) / total) * 100);
                    $this.find('.progress-pixel').css({width: percent + '%'});
                    $this.find('.progress-text').html(percent + '% (' + (index + 1) + '/' + total + ')');
                }
            });
        });
    },

    spaceDropPlaceholder: function (list, items, beforDrag) {
        // add padding for dropping if page is empty
        if ((beforDrag && items.length == 1) ||
            (!beforDrag && items.length == 0)) {
            $(list).addClass('questionBorder').css('padding', '20px 0');
        } else {
            $(list).removeClass('questionBorder').css('padding', '0');
        }
    },

    findItemBlock: function (root) {
        if (!is_function(root.parent)) {
            root = $(root);
        }
        var curElm = root;
        while (is_function(curElm.parent) && curElm.parent()) {
            if (curElm.attr('id')) {
                const parts = curElm.attr('id').split('_');
                if (parts[0] == 'page' || parts[0] == 'pageitem') {
                    return {
                        type: parts[0],
                        id: parts[1],
                        elm: curElm
                    };
                }
            }
            curElm = curElm.parent();
        }
        return {};
    },

    refreshTheme: function () {
        var onSuccess = function () {
            // no theme switch anymore
            // Toasts.successToast(json.message);
            // LP.Poll.setThemeCSS(json.cssFileName);
            // if (json.themeColorPanel) {
            // 	$('#lp-polltheme-colors').html(json.themeColorPanel);
            // 	LP.dlgThemeColors.init();
            // }
            // if (json.pollHTML) {
            // 	LP.questionairePage.replacePollHTML(json);
            // }
        };

        window.Browser.send('backend/setPollTheme/', 'poll=' + $('#pollId').val() + '&theme=' + $('#lp-poll-theme').val(), onSuccess);
    },

    refreshThemeSettings: function (position) {
        const settingsDialog = $('#lp-settings-dialog');

        settingsDialog.find('input[name="pollLayout[logoPosition]"]').attr('checked', false);
        settingsDialog.find('input[name="pollLayout[logoPosition]"][value=' + position + ']').attr('checked', 'checked');
    },

    refreshCSS: function (json) {
        var customSurveyCSS = $('#customSurveyCSS');
        if (customSurveyCSS.length) {
            customSurveyCSS.text(json.css);
        }
    },

    toggleProgressbar: function () {
        var $this = $(this);
        var state;
        $this.blur();

        var checked = $this.is(':checked');

        if (checked) {
            $('.lp-progress-overlay', $this.parent()).hide();
            state = '0';
        } else {
            $('.lp-progress-overlay', $this.parent()).fadeIn(200);
            state = '1';
        }

        window.Browser.send('backend/setProgressBarForPage/', 'poll=' + $('#pollId').val() + '&page=' + $this.attr('page') + '&state=' + state);
    },

    toggleLanguagebar: function () {
        var $this = $(this);
        var state;
        $this.blur();
        if ($this.is(':checked')) {
            $('.lp-language-togglearea .languages').removeClass('lp-inactive');
            $('.lp-languages-checkbox').prop('checked', true);
            state = '1';
        } else {
            $('.lp-language-togglearea .languages').addClass('lp-inactive');
            $('.lp-languages-checkbox').prop('checked', false);
            state = '0';
        }

        window.Browser.send('backend/setLanguageBar/', 'poll=' + $('#pollId').val() + '&state=' + state);
    },

    toggleLogo: function () {
        var $this = $(this);
        var state;
        var parent = $this.closest('.lp-logo');
        if ($this.is(':checked')) {
            state = '0';
            $('.pollLogo', parent).removeClass('lp-inactive');
            $('.lp-logo-overlay', parent).hide();

            if ($('.pollLogo', parent).attr('src')) {
                $('.lp-deletelogo-button', parent).show();
                $('.lp-rightLogo-button', parent).show();
                $('.lp-leftLogo-button', parent).show();
            }

        } else {
            state = '1';
            $('.pollLogo', parent).addClass('lp-inactive');
            $('.lp-logo-overlay', parent).fadeIn(200);
            $('.lp-deletelogo-button', parent).hide();
            $('.lp-rightLogo-button', parent).hide();
            $('.lp-leftLogo-button', parent).hide();
        }

        window.Browser.send('backend/setLogoForPage/', 'poll=' + $('#pollId').val() + '&page=' + $this.attr('page') + '&state=' + state, function () {
            // Toasts.successToast(json.message);  //json is empty
        });
    },

    initLogoForm: function (logo) {
        var $logo = $(logo);
        var $popup = $(this);
        $popup.find('.pageIdent').val($logo.find('.pageIdent').val());
        $popup.find('[action="save"]').on('click', function () {
            LP.questionairePage.submitLogoForm($popup);
            $logo.popup('hide');
        });
        $popup.find('[action="cancel"]').on('click', function () {
            $logo.popup('hide');
        });
    },

    submitLogoForm: function ($logoForm) {
        var oldSource = $('.pollLogo').attr('src');
        var $fileinput = $logoForm.find('.lp-file-upload-input');

        if ($fileinput.val().length > 0) {
            var tmpId = createRandomId();
            $fileinput.attr('id', tmpId);
            // const imgSrc = $logoForm.find('.img-preview img').attr('src');

            var onSuccess = function (json) {
                LP.dlgPollValidation.doRefresh = true;
                if (json.image_url) {
                    var src = json.image_url;
                    $('.pollLogo').attr('src', src);
                    $('.lp-deletelogo-button').each(function (index, elm) {
                        var $elm = $(elm);
                        var parent = $elm.closest('.lp-logo');
                        if ($('[action="toggleLogo"]:checked', parent).length > 0) {
                            $elm.show();
                        }
                    });
                }
                $('.lp-logo .legy-marker.ui.warning.message,.lp-no-logo').hide();
                $('.pollLogo').show();
                window.Toasts.successToast(json.message);

            };

            var onError = function (json) {
                is_array(json.errors) && json.errors.forEach(function (err) {
                    return window.Toasts.errorToast(err);
                });

                if (oldSource) {
                    $('.pollLogo').attr('src', oldSource);
                } else {
                    $('.pollLogo').hide();
                    $('.lp-no-logo').show();
                }
            };

            window.Browser.upload('backend/uploadPollLogo/', {
                poll: $('#pollId').val(),
                // imgSrc: imgSrc
            }, tmpId).then(onSuccess).catch(onError);
        }

        return true;
    },

    deleteLogo: function () {
        window.Browser.send('backend/deleteLogo/', 'poll=' + $('#pollId').val(), function () {
            $('.lp-no-logo').show();
            $('.pollLogo').attr('src', '').hide();
            $('.lp-deletelogo-button').hide();
            $('.lp-rightLogo-button').hide();
            $('.lp-leftLogo-button').hide();
            $('.lp-logo .legy-marker.ui.warning.message').hide();
        });

        return false;
    },

    moveLogoToTheRight: function (e) {
        const $button = $(this),
            $logo = $button.closest('.lp-logo'),
            position = $logo.data('position'); //Position -> 0 = 'left', 1='center', 2='right'

        e.stopPropagation();
        if (position == 2 || $button.hasClass('disabled')) {
            return;
        }

        window.Browser.send('backend/setLogoPosition/', 'poll=' + $('#pollId').val() + '&position=' + (position + 1), function (json) {
            LP.questionairePage.refreshThemeSettings(position + 1);
            LP.questionairePage.replacePollHTML(json);
        });
    },

    moveLogoToTheLeft: function (e) {
        const $button = $(this),
            $logo = $button.closest('.lp-logo'),
            position = $logo.data('position'); //Position -> 0 = 'left', 1='center', 2='right'

        e.stopPropagation();

        if (position == 0 || $button.hasClass('disabled')) {
            return;
        }

        window.Browser.send('backend/setLogoPosition/', 'poll=' + $('#pollId').val() + '&position=' + (position - 1), function (json) {
            LP.questionairePage.refreshThemeSettings(position - 1);
            LP.questionairePage.replacePollHTML(json);
        });

    }

};